import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { ConsentBanner } from "@/components/ConsentBanner";
import { track, gaPageView, initGaConsent, hasConsent } from "@/lib/track";
import Home from "@/pages/Home";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import AcademyProgram from "@/pages/AcademyProgram";
import DownloadPage from "@/pages/DownloadPage";
import InsightPage from "@/pages/InsightPage";
import { PrivacyPolicy, CookiePolicy } from "@/pages/Legal";

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    if (!location.pathname.startsWith("/admin")) {
      track("page_view");
      if (hasConsent()) gaPageView(location.pathname);
    }
  }, [location.pathname]);
  // Auth callback: process session_id from URL fragment before any routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<SmoothScroll><Home /></SmoothScroll>} />
      <Route path="/academy/:slug" element={<AcademyProgram />} />
      <Route path="/download/:token" element={<DownloadPage />} />
      <Route path="/insights/:slug" element={<InsightPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  useEffect(() => { initGaConsent(); }, []);
  return (
    <div className="App">
      <div className="grain" />
      <Toaster position="top-center" richColors />
      <ConsentBanner />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
